<template>
  <div class="new-address-main">
    <el-form :inline="true" class="demo-form-inline" :model="oldAdresss" :rules="rules" ref="oldAdresss">
      <el-form-item label-width="50px" label="IP" prop="address">
        <el-input class="new-address-main-item" v-model="oldAdresss.address"></el-input>
      </el-form-item>
      <el-form-item label-width="50px" :label="$translate('lang.E3202103100010', { defaultText: '端口' })" prop="port">
        <el-input  class="new-address-main-item" v-model.number="oldAdresss.port"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
    props: ['oldAdress'],
    data() {
        return {
            oldAdresss: this.oldAdress,
            rules: {
                address: [
                    { required: true, message: this.$translate('lang.E3202103100022', { defaultText: '请输入地址' }), trigger: 'blur' }
                ],
                port: [{ type: 'number', required: true, message: this.$translate('lang.E3202103100023', { defaultText: '请输入端口' }), trigger: 'blur' }]

            }
        };
    }

};
</script>
<style lang="less">
.new-address-main{
  .el-form-item{
    margin-right: 0;
  }
  .el-form-item__label{
    padding: 0 10px 0 0;
  }
  .new-address-main-item{
    width: 264px;
  }
}
</style>